import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_clock_svg = _resolveComponent("clock-svg")!

  return (_ctx.delayedTime && _ctx.state.leftTime)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.getClass)
      }, [
        _createVNode(_component_clock_svg, { class: "mr-1" }),
        _createTextVNode(" " + _toDisplayString(_ctx.state.leftTime), 1)
      ], 2))
    : _createCommentVNode("", true)
}